"use client";

import React from "react";
import { Play, Clock, BookOpen, MonitorPlay } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const videoLibrary = [{
  id: "vid-001",
  topicCode: "LEADERSHIP",
  title: "1. Breakthrough Protection Calls",
  duration: "12:45",
  thumbnail: "https://newmavericks.com/wp-content/uploads/2026/03/one-to-1.jpg?v=er840p5crxu",
  description: "60 min calls every two weeks\n\n\xA0These are very personalized calls that give you the most relevant awareness to see, believe and know the truth that will make you and your team victorious in the challenges & opportunities you have.\n\n\xA0We enable you to purify & simplify your most pressing issues & obstacles to move forward in the most progressive protected way possible by getting 3-4X faster buy-in to your deals and objectives to: - maximize revenue growth - secure investment & finance - minimize costly mistakes & stress - maximize cohesion and coherence with all stakeholders"
}, {
  id: "vid-002",
  topicCode: "MINDSET",
  title: "2. On-Demand Boost Calls",
  duration: "15:20",
  thumbnail: "https://newmavericks.com/wp-content/uploads/2026/03/warren_buffett_investment.webp?v=og7gf54st9b",
  description: "On-demand calls any time for situations that require extra attention, insight and support so you're on the front foot to maximize opportunities and minimize problems."
}, {
  id: "vid-003",
  topicCode: "STRATEGY",
  title: "3. World Class Brain Coherence Technique",
  duration: "10:15",
  thumbnail: "https://newmavericks.com/wp-content/uploads/2026/03/a_brain_operating_at_peak_performance.png?v=f5ng81w9ddw",
  description: "A simple effortless natural mental technique backed by over 600 studies that gives you an even more settled coherent alert mind to have the right thoughts at the right time to make the best decisions. Research has found when top CEOs & athletes are performing at their best, making their best decisions they have a unique style of coherent brain functioning that allows them to see the bigger vision and spontaneously focus on the finer details to fulfill that vision."
}, {
  id: "vid-004",
  topicCode: "PERFORMANCE",
  title: "4. Coherence Protection Technology",
  duration: "18:30",
  thumbnail: "https://newmavericks.com/wp-content/uploads/2026/03/science_of_protection_diagram.webp?v=kejdx31av9",
  description: "A time & field proven coherence creating technology that protects and evolves you and your energy to accelerate your progress by:\n\n\n- minimizing & averting dangers, treats, losses and problems before they arise\n\n\n- maximizing the ability to see and create opportunities\xA0\nas they arise.\n\n\nThese are specific to you and bring timely knowledge & support for timely action.\n\n"
}, {
  id: "vid-005",
  topicCode: "CULTURE",
  title: "5. Total Health Protection Supplement",
  duration: "14:50",
  thumbnail: "https://newmavericks.com/wp-content/uploads/2026/03/amla.jpg?v=8wzvwv69muq",
  description: "An all natural organic nutritional supplement proven to strengthen brain connectivity, nervous and immune systems so you have more mental capacity, strength and protection to lead things forward without compromising your health."
}, {
  id: "vid-006",
  topicCode: "SUCCESS",
  title: "6. The Science of Protection Book, eBook & Audiobook",
  duration: "22:10",
  thumbnail: "https://newmavericks.com/wp-content/uploads/2026/03/Ebook-Front-Cover_The-Science-of-Protection_Web_Preview-copy-1.png?v=2sw518x484i",
  description: "This is a 6-step journey through our\xA0 Science of Protection to protect you and your team's science of achievement. (Paperback, eBook and audio copies for you and\xA0 all your executive team)"
}];
export default function VideoCopy() {
  return <section data-section-id="168412" id="videopresentation" className="bg-background text-black py-20 ![margin:0px_0px_-30px_0px] md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ![margin:-60px_0px_64px_0px]">
          <div className="max-w-3xl">
            <h2 className="font-display text-4xl font-bold tracking-tight ![margin:-20px_0px_24px_0px] !text-[hsl(0,0%,100%)] md:text-5xl">CEO BREAKTHROUGH PROTECTION PROGRAM</h2>
            <p className="text-lg leading-relaxed font-sans !text-[hsl(0,0%,100%)]">We operate as CEO breakthrough protection partners, not coaches, advisors or consultants, because we work from the deepest level of developing a CEO's leadership consciousness &amp; capacity and integrate this into improving business performance.<div><br /></div><div>Our initial 3 month program is a 2-3 hour per month personalized program is based on your #1 90 day intention.&nbsp;</div><div><br /></div><div>Through applying our Science &amp; Technologies of Protection we guarantee significant breakthrough achievement &amp; protected progress in fulfilling this intention.</div><div><br /></div><div>Working with us gives you a 10-15% edge that can make all the difference between breaking through or remaining stagnant, or worst of all breaking down altogether and having to step down.</div><div><br /></div><div>We take FULL &amp; COMPLETE responsibility &amp; accountability with you to ensure you get the BREAKTHROUGH progress you want.</div><div><br /></div><div>We delivered our program through the following approaches:</div><div><br /></div></p>
          </div>
          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-[480px]">
              <AspectRatio ratio={3 / 4}>
                <img src="https://newmavericks.com/wp-content/uploads/2026/02/science_protection_detail.webp" alt="CEO Leadership Excellence" className="rounded-lg shadow-strong object-cover w-full h-full" />
              </AspectRatio>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {videoLibrary.map((video, index) => <div key={video.id} data-index={index} className="col-span-12 md:col-span-6 lg:col-span-4">
              <Dialog>
                <Card className="h-full rounded-lg border border-black/10 bg-white shadow-soft hover:shadow-strong transition-all duration-300 overflow-hidden flex flex-col group">
                  <DialogTrigger asChild>
                    <div className="relative cursor-pointer bg-slate-200">
                      <AspectRatio ratio={16 / 9}>
                        <img src={video.thumbnail} alt={video.title} className="object-contain w-full h-full transition-transform duration-500 group-hover:scale-105" />
                        <div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition-colors duration-300" />
                        
                        {}
                        <div className="absolute inset-0 flex items-center justify-center opacity-90 group-hover:opacity-100 transition-opacity duration-300">
                          
                        </div>
                      </AspectRatio>
                    </div>
                  </DialogTrigger>
                  
                  <CardContent className="p-6 flex-1 flex flex-col">
                    
                    
                    <h3 className="font-display text-xl font-bold leading-tight mb-3 text-black group-hover:text-accent transition-colors">
                      {video.title}
                    </h3>
                    
                    <p className="text-slate-600 text-sm leading-relaxed font-sans !m-0">
                      {video.description}
                    </p>
                  </CardContent>
                </Card>

                <DialogContent className="sm:max-w-4xl p-0 overflow-hidden bg-black border-none rounded-lg">
                  <div className="sr-only">
                    <DialogTitle>{video.title}</DialogTitle>
                    <DialogDescription>Video player for {video.title}</DialogDescription>
                  </div>
                  <AspectRatio ratio={16 / 9} className="bg-black flex items-center justify-center relative">
                    {}
                    <img src={video.thumbnail} alt={`${video.title} poster`} className="absolute inset-0 w-full h-full object-contain opacity-40" />
                    <div className="relative z-10 flex flex-col items-center text-white text-center px-4">
                      <div className="w-20 h-20 bg-accent rounded-full flex items-center justify-center mb-6 shadow-strong animate-pulse">
                        <Play className="w-8 h-8 fill-current text-white ml-1" />
                      </div>
                      <p className="font-sans text-sm tracking-[0.2em] uppercase text-accent font-bold">New Mavericks Presentation</p>
                      <p className="font-display text-2xl font-bold mt-4 max-w-2xl">{video.title}</p>
                      <div className="mt-8 flex gap-4">
                        <button className="bg-accent hover:bg-accent-hover text-white px-8 py-3 rounded-md font-bold transition-colors">
                          Play Full Experience
                        </button>
                      </div>
                    </div>
                  </AspectRatio>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>

      </div>
    </section>;
}